import { SubscriptionTypeEnum, UserTypeEnum } from "../types/shared";

const getUserType = (isProjectAdmin: boolean, subscriptionType: SubscriptionTypeEnum): UserTypeEnum => {
    if (isProjectAdmin && subscriptionType === SubscriptionTypeEnum.None) {
        return UserTypeEnum.ProjectAdmin;
    }

    if (isProjectAdmin && subscriptionType === SubscriptionTypeEnum.Wave) {
        return UserTypeEnum.UserAndProjectAdmin;
    }

    return UserTypeEnum.User;
};

export default getUserType;
